import { IOption } from '../../components/forms/search-input/BpSearchInput'

/**
 * Опции для мультивыбора, значением которого служит текст, а не id: отчёты ждут
 * `keyword=<текст>`, а подсказки приходят с сервера под строку поиска. Уже выбранные
 * значения добавляются в список сами — иначе они пропадут из поля, как только
 * подсказки сузятся под новый запрос.
 */
export const toTextOptions = (options: IOption[] = [], value?: string): IOption[] => {
  const selected = value ? value.split(',').filter(Boolean) : []
  const result: IOption[] = selected.map((text) => ({ text, value: text }))

  options.forEach(({ text }) => {
    if (!result.some((option) => option.value === text)) result.push({ text, value: text })
  })

  return result
}
